const category = 'Aside panel';

export const SegmentAsidePanelEvent = {
    BUTTONS_PANEL_MINIMIZE_CLICKED: { category, event: 'Buttons panel minimize clicked' },
    BUTTONS_PANEL_EXPAND_CLICKED: { category, event: 'Buttons panel expand clicked' },
    SCROLL_TOP_BY_TAB_CLICK: { category, event: 'Scroll top by tab click' },
};
